import InfoButton from '../../components/shell/InfoButton'
import AppHeader from '../../components/shell/AppHeader'
import SupervisorNav from '../../components/supervisor/SupervisorNav'
import { useProfileIdentity } from '../../lib/useProfileIdentity'
import { REPORT_CATALOG, type ReportId } from './reportCatalog'
import ReportTabs from './ReportTabs'

export default function SupervisorReportPage({ report }: { report: ReportId }) {
  const identity = useProfileIdentity()
  const { title, subtitle, about, Component } = REPORT_CATALOG.find((entry) => entry.id === report)!
  return (
    <div className="flex h-dvh flex-col bg-surface text-ink print:block print:h-auto">
      <a
        href="#report-main"
        className="sr-only focus:not-sr-only focus:absolute focus:z-50 focus:m-2 focus:rounded focus:bg-canvas focus:px-4 focus:py-2 focus:font-semibold"
      >
        Skip to main content
      </a>

      <div className="print:hidden">
        <AppHeader initials={identity?.initials ?? ''} />
      </div>

      <main id="report-main" tabIndex={0} className="relative flex flex-1 flex-col overflow-y-auto p-4 sm:p-6 lg:p-8 print:block print:overflow-visible print:p-0">
        <SupervisorNav />
        <div className="mx-auto flex w-full max-w-[1400px] flex-1 flex-col gap-5">
          <div>
            <div className="flex items-center gap-0.5">
              <h1 className="text-h2 font-extrabold">{title}</h1>
              <InfoButton label={`About the ${title}`}>
                {about.map((paragraph) => (
                  <p key={paragraph} className="[&:not(:first-child)]:mt-2">
                    {paragraph}
                  </p>
                ))}
              </InfoButton>
            </div>
            <p className="text-small text-ink-muted">{subtitle}</p>
          </div>
          <ReportTabs base="/supervisor/reports" />
          <Component />
        </div>
      </main>
    </div>
  )
}
